import "../Login/Login.css";
import Header from "../../components/Layouts/Header";
import Layout from "../../components/Layouts/Layout";
import Footer from "../../components/Layouts/Footer";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import Instance from "../../Utils/Axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { showToast } from "../../Utils/index";
import useFormValidation from "../../Hooks/useformValidation";
import { newpasswordSchema } from "../../Utils/validationSchema";
import { FormGroup } from "react-bootstrap";

export default function NewPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [apiData, setApiData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation(); // 👈 get location
  const queryParams = new URLSearchParams(location.search);
  const emailFromQuery = queryParams.get("email");
  const otpFromQuery = queryParams.get("otp");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormValidation(newpasswordSchema);

  useEffect(() => {
    // fetchOTPData();
  }, []);

  // const fetchOTPData = () => {
  //   setLoading(true);
  //   Instance.get("/customer/resetPassword")
  //     .then((response) => {
  //       setApiData(response.data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       setError("Failed to fetch OTP data. Please try again.");
  //       console.error("Error fetching OTP data:", error);
  //     });
  // };

  const handleResetPassword = (data) => {
    // e.preventDefault();
    setLoading(true);
    Instance.post("/user/resetPassword", {
      email: emailFromQuery,
      otp: otpFromQuery,
      password: data.password,
    })
      .then((response) => {
        setLoading(false);
        showToast("Reset Password successful!", "success", "success");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        setError("Error resetting password. Please try again.");
        console.error("Error resetting password:", error);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("tokenId");
    if (token) {
      showToast("You are already logged in!", "success", "success");
      setTimeout(() => {
        navigate("/customer/dashboard");
      }, 1500);
    }
  }, [navigate]);

  return (
    <>
      <div className="full_screen">
        <Header />
        <div className="content">
          <Layout>
            <>
              <div className={`col-6 new_pass_container`}>
                <h1>Setup New Password</h1>
                <Form onSubmit={handleSubmit(handleResetPassword)}>
                  <div className={`new_pass_wrapper`}>
                    {/* <FormGroup>
                    <Form.Control
                      type="Email"
                      placeholder="Enter your registered email address"
                      {...register("email")}
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                    {errors.email?.message}
                  </Form.Control.Feedback>
                  </FormGroup> */}
                    {/* <FormGroup>
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP"
                      {...register("otp")}
                      isInvalid={!!errors.otp}
                    />
                    <Form.Control.Feedback type="invalid">
                    {errors.otp?.message}
                  </Form.Control.Feedback>
                  </FormGroup> */}
                    <FormGroup className="password-wrapper">
                      <div className="input-icon-wrapper">
                        <Form.Control
                          type={visible ? "text" : "password"}
                          placeholder="Enter your password"
                          {...register("password")}
                          isInvalid={!!errors.password}
                        />
                        <img
                          className="toggle-password-icon"
                          src="/build/eye.svg"
                          onClick={() => setVisible(!visible)}
                          width={24}
                          height={24}
                          alt="toggle visibility"
                        />
                      </div>
                      <Form.Control.Feedback type="invalid" className="d-block feedback-message">
                        {errors.password?.message}
                      </Form.Control.Feedback>
                    </FormGroup>
                    <FormGroup className="password-wrapper">
                      <div className="input-icon-wrapper">
                        <Form.Control
                          type={visible2 ? "text" : "password"}
                          placeholder="Re-enter your password"
                          {...register("confirmPwd")}
                          isInvalid={!!errors.confirmPwd}
                        />
                        <img
                          className={errors.confirmPwd ? "toggle-password-icon1" : "toggle-password-icon"}
                          src="/build/eye.svg"
                          onClick={() => setVisible2(!visible2)}
                          width={24}
                          height={24}
                          alt="toggle visibility"
                        />
                        <Form.Control.Feedback type="invalid" className="d-block feedback-message">
                          {errors.confirmPwd?.message}
                        </Form.Control.Feedback>
                      </div>

                    </FormGroup>
                    {successMessage && (
                      <p className="text-success">{successMessage}</p>
                    )}
                    {error && <p className="text-danger">{error}</p>}
                    <button
                      className={`signin_btn`}
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Processing" : "Reset Password"}
                    </button>
                    <p className={`mb-0 text-center  or`}>OR</p>
                    <div className={`d-flex justify-content-between`}>
                      <div className={`d-flex gap-2 auth_btn`}>
                        <img
                          className={"logo"}
                          src="/build/Google_Logo.svg"
                          alt="zex pr wire Logo"
                          width={24}
                          height={24}

                        />
                        <p>Sign in with Google</p>
                      </div>
                      <div className={`d-flex gap-2 auth_btn auth_btn_two`}>
                        <img
                          className={"logo"}
                          src="/build/Google_Logo.svg"
                          alt="zex pr wire Logo"
                          width={24}
                          height={24}

                        />
                        <p>Sign in with Apple</p>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          </Layout>
        </div>
      </div>
    </>
  );
}
